// Industry-aware Vendor Power Up demo templates.

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

const VENDOR_MAP_POSITIONS = [
  { x: 30, y: 68 },
  { x: 44, y: 72 },
  { x: 68, y: 70 },
  { x: 80, y: 76 },
  { x: 24, y: 52 },
  { x: 76, y: 52 },
];

const slugify = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const buildVendorDefaults = ({
  industryTemplate = "car_show",
  demoSize = "medium",
} = {}) => {
  const vendorPool = getPowerUpProfile(industryTemplate).vendors;
  const vendorLimit = getVendorLimit(demoSize, vendorPool.length);

  return vendorPool.slice(0, vendorLimit).map(([name, type], index) => {
    const slug = slugify(name);
    const mapPosition = VENDOR_MAP_POSITIONS[index % VENDOR_MAP_POSITIONS.length];

    return {
      name,
      type,
      category: type,
      description: `${name} brings ${type.toLowerCase()} services to this event experience.`,
      contactName: `${name} Event Team`,
      contactEmail: `events@${slug}.example`,
      vendorContactEmail: `events@${slug}.example`,
      website: `https://${slug}.example`,
      url: `https://${slug}.example`,
      facebook: `https://facebook.com/${slug}`,
      instagram: `https://instagram.com/${slug.replace(/-/g, "")}`,
      boothNumber: `V-${String(index + 1).padStart(2, "0")}`,
      displayOrder: (index + 1) * 10,
      featuredVendor: index < 2,
      mapMarkerLabel: `V${index + 1}`,
      mapMarkerTitle: name,
      mapMarkerNote: type,
      mapMarkerType: "vendor",
      mapMarkerColor: "primary",
      mapMarkerX: mapPosition.x,
      mapMarkerY: mapPosition.y,
      logoUrl: "",
      approvalStatus: "approved",
      paymentStatus: "not_required",
      demoSeed: true,
    };
  });
};

const getVendorLimit = (demoSize, maxCount) => {
  switch (demoSize) {
    case "small":
      return Math.min(3, maxCount);
    case "large":
      return Math.min(6, maxCount);
    case "xlarge":
      return Math.min(8, maxCount);
    case "medium":
    default:
      return Math.min(4, maxCount);
  }
};
